var _path, _path2, _path3, _g, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOther(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 266,
    height: 332,
    viewBox: "0 0 266 332",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.378e-06 90V295C-0.00131202 299.766 0.936261 304.485 2.75879 308.888C4.58132 313.292 7.25316 317.293 10.6221 320.664C13.991 324.035 17.9909 326.709 22.3933 328.534C26.7957 330.359 31.5144 331.299 36.28 331.3H228.79C233.558 331.301 238.279 330.363 242.685 328.54C247.09 326.716 251.093 324.042 254.465 320.672C257.836 317.301 260.511 313.299 262.336 308.894C264.161 304.489 265.1 299.768 265.1 295V36.3C265.1 31.5322 264.161 26.8111 262.336 22.4063C260.511 18.0015 257.836 13.9994 254.465 10.6285C251.093 7.2576 247.09 4.58397 242.685 2.76032C238.279 0.936659 233.558 -0.00131207 228.79 1.37752e-06H90.02L18.8401 71.15L1.378e-06 90Z",
    fill: "#F7F7FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 90L18.8401 71.15L90.02 1.37752e-06H228.79C233.558 -0.00131207 238.279 0.936659 242.685 2.76032C247.09 4.58397 251.093 7.2576 254.465 10.6285C257.836 13.9994 260.511 18.0015 262.336 22.4063C264.161 26.8111 265.1 31.5322 265.1 36.3V120.71H0V90Z",
    fill: "#6A1B9A"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 89.99L44.4302 99.81C53.8607 101.751 63.676 99.8692 71.72 94.5779C79.7639 89.2865 85.3784 81.0184 87.3301 71.59L89.1802 61.41C88.5954 64.2187 87.6615 66.9432 86.4001 69.52C83.4313 75.6574 78.7922 80.8334 73.0154 84.4541C67.2385 88.0748 60.558 89.9935 53.7402 89.99H0Z",
    fill: "#D7D7D7"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 89.99H53.7402C60.558 89.9935 67.2385 88.0748 73.0154 84.4541C78.7922 80.8334 83.4313 75.6574 86.4001 69.52C87.6615 66.9432 88.5954 64.2187 89.1802 61.41C89.7413 58.8753 90.0195 56.2861 90.01 53.69V0L18.8401 71.16L0 89.99Z",
    fill: "#EFEFEF"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M219.26 272.37H45.8398V175.3H219.26V272.37ZM56.97 261.24H208.12V186.44H56.97V261.24Z",
    fill: "#6A1B9A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M105.73 180.87H94.5898V266.81H105.73V180.87Z",
    fill: "#6A1B9A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M213.688 218.27H51.3984V229.41H213.688V218.27Z",
    fill: "#6A1B9A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOther);
export default __webpack_public_path__ + "static/media/other.9d46ccb491dbf67ac4e6a44e769ccde6.svg";
export { ForwardRef as ReactComponent };